module.exports = "/_next/static/images/game2-results-background-38facf9adef1892aa35f904619fed96d.jpg";